import { Col, ProgressBar, Row } from "react-bootstrap";
import { useEffect, useState } from "react";

const PasswordStrengthMeter = ({ colConfig, passwordRule, value }) => {

  //console.log("PasswordStrengthMeter", colConfig, passwordRule, value);
  const [passwordStrength, setPasswordStrength] = useState({
    text: "Weak",
    value: 33,
    valueColor: "danger"
  });

  useEffect(() => {
    evaluatePWDStrength(passwordRule, value)
  }, [passwordRule])

  // evaluate password strength
  const evaluatePWDStrength = (passwordRule, value) => {
    let res = {
      text: "Weak",
      value: 33,
      valueColor: "danger"
    }

    let charCheck = false;
    let charCheckCount = 0;

    for (const key in passwordRule.characterCheck) {
      if (key === "hasSpecialCharCheck") {
        continue;
      }

      if (key !== "specialCharCheck" && passwordRule.characterCheck[key] === true) {
        charCheckCount++;
      }

      if (key === "specialCharCheck") {
        if (passwordRule.characterCheck[key] === false) {
          charCheckCount = 0;
          break;
        } else if (passwordRule.characterCheck[key] === true && passwordRule.characterCheck["hasSpecialCharCheck"] === true) {
          charCheckCount++;
        }
      }
    }

    if (charCheckCount >= 3) {
      charCheck = true;
    }

    // weak: not meeth all the rules
    for (const key in passwordRule) {
      if (key === "characterCheck") {
        if (!charCheck) {
          setPasswordStrength(res);
          return;
        }
      }

      if (key === "countLimitCheck") {
        continue;
      }

      if (!passwordRule[key]) {
        setPasswordStrength(res);
        return;
      }
    }

    // sufficient: 
    //meet each rule, 
    //length <= 18
    //No special character
    let specialCharCheck = /[@!#$%&*()_+\-=\[\]?]/;
    let specialCharFlag = false;

    if (specialCharCheck.test(value)) {
      specialCharFlag = true;

    }

    if (value.length <= 18 && !specialCharFlag) {
      setPasswordStrength({
        text: "Sufficient",
        value: 66,
        valueColor: "warning"
      });
      return;
    }

    // strong:
    // length > 18
    // includes a special char
    if (value.length > 18 || specialCharFlag) {
      setPasswordStrength({
        text: "Strong",
        value: 100,
        valueColor: "success"
      });
    }
  }

  return (
    <>
      {value?.length > 0 ?
        <>
          <Row>
            <Col lg={colConfig.labelCols.lg} md={colConfig.labelCols.md} >
              {passwordStrength.text}
            </Col>
            <Col lg={colConfig.inputCols.lg} md={colConfig.inputCols.md} className=" passwordMeterLabel">
              <ProgressBar now={passwordStrength.value} variant={passwordStrength.valueColor}></ProgressBar>
            </Col>
          </Row>
          <br />
        </>
        : null}
    </>
  )
}

export default PasswordStrengthMeter;